var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var StrikesBallsOuts = /** @class */ (function (_super) {
    __extends(StrikesBallsOuts, _super);
    function StrikesBallsOuts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StrikesBallsOuts.prototype.render = function () {
        return (React.createElement("span", null,
            React.createElement("span", { className: "rj-baseball-scoreboard-balls" }, "" + this.props.ballsTranslation + this.props.balls),
            React.createElement("span", { className: "rj-baseball-scoreboard-strikes" }, "" + this.props.strikesTranslation + this.props.strikes),
            React.createElement("span", { className: "rj-baseball-scoreboard-outs" }, "" + this.props.outsTranslation + this.props.outs)));
    };
    return StrikesBallsOuts;
}(React.PureComponent));
export { StrikesBallsOuts };
//# sourceMappingURL=StrikesBallsOuts.js.map